import { logErrors } from '@/api/logger'

export default {
    install(Vue, options) {
        function log(type, title, text) {
            var data = { error: title + ":" + text };
            return new Promise((resolve, reject) => {
                logErrors(data).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        }

        Vue.prototype.$log = {
            error(title, text) { log('danger', title, text) },
            success(title, text) { log('success', title, text) },
            log
        }
    }
}